var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.m0 ? '' : 'mr-1',attrs:{"src":require(("@/assets/images/icons/ic_" + _vm.name + ".svg")),"width":_vm.width || '15%'},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }